document.addEventListener('DOMContentLoaded', function() {
    const filterGroups = document.querySelectorAll('.archive-products-filters-group');

    /**
     * Accordion: close other filter groups when one opens (progressive enhancement)
     */
    filterGroups.forEach(group => {
        group.addEventListener('toggle', function() {
            if (group.open) {
                filterGroups.forEach(other => {
                    if (other !== group) other.open = false;
                });
            }
        });
    });

    /**
     * Close open filter group when clicking outside it
     */
    document.addEventListener('click', function(event) {
        const openGroup = document.querySelector('.archive-products-filters-group[open]');
        if (openGroup && !openGroup.contains(event.target)) {
            const summary = event.target.closest('.archive-products-filters-label');
            if (!summary) {
                openGroup.open = false;
            }
        }
    });
});
